<template>
  <QDialog v-model="show" transition-show="scale" transition-hide="scale">
    <QCard>
      <QCardSection class="column items-center q-pa-lg">
        <div class="row justify-between items-center full-width no-wrap">
          <h6 class="q-ma-none text-secondary col-shrink">Oops!</h6>
          <SAIIconBtn v-close-popup />
        </div>
        <div class="q-mb-none q-mt-sm text-grey-9">
          <span class="text-paragraph">An unexpected error has occurred.</span>
          <span class="text-paragraph" v-if="contactNumber">
            Please call us on
            <SAILink
              :href="`tel:${contactNumber}`"
              target="_blank"
              :label="contactNumber"
            />
          </span>
        </div>
      </QCardSection>
      <QCardActions class="q-pb-lg q-pt-none q-px-lg" v-if="action">
        <QBtn
          outline
          class="q-px-sm q-py-xs EUIBtn"
          color="grey-7"
          label="Try Again"
          @click="tryAgain"
          :loading="actionLoading"
          :disabled="actionLoading"
        />
      </QCardActions>
    </QCard>
  </QDialog>
</template>

<script>
import {
  QDialog,
  QCard,
  QCardSection,
  QCardActions,
  QBtn,
  ClosePopup
} from 'quasar';
import { mapState } from 'vuex';
import { getTheme, SAIIconBtn, SAILink } from 'ecx.saigon.ui.common';

export const GLOBAL_ERROR = 'GLOBAL_ERROR';

/**
 * This component displays a global error message as a Dialog which provides the ability to re try an action.
 * To invoke the UI, call:
 * @code this.$euiNotifications.emit({
            notification: GLOBAL_ERROR,
            action: () => {
              return;
            }
          });
 * passing an action param in the emit payload is optional and if omitted, will not display the action button.
 */
export default {
  name: 'GlobalError',
  data() {
    return {
      show: false,
      action: null,
      actionLoading: false,
      errorStack: 0,
      actionParams: undefined
    };
  },
  computed: {
    ...mapState({
      user: (state) => state.user.user
    }),
    contactNumber() {
      return getTheme(this.user.entity).support.phone;
    }
  },
  watch: {
    show: function (value) {
      if (!value) {
        this.action = null;
      }
    }
  },
  methods: {
    tryAgain: async function () {
      // Perform the action
      this.actionLoading = true;
      await this.action(this.actionParams);
      // Resolve the action loading state
      this.actionLoading = false;
      this.errorStack--;
      // Do not close the popup If there was an error emitted while the action was in progress
      if (!this.errorStack) {
        this.show = false;
      }
    }
  },
  beforeCreate() {
    this.$euiNotifications.EventBus.$on(GLOBAL_ERROR, (params) => {
      this.$nextTick(function () {
        this.errorStack++;
        this.action = params.action;
        this.actionParams = params.actionParams;
        this.show = true;
      });
    });
  },
  directives: {
    ClosePopup
  },
  components: {
    QDialog,
    QCard,
    QCardSection,
    QCardActions,
    QBtn,
    SAIIconBtn,
    SAILink
  }
};
</script>
